import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';

import { AppComponentPluginModule } from '../plugin/app-component-plugin.module';
import { TopbarButtonComponent } from './topbar-button/topbar-button.component';
import { MainbarOptionComponent } from './mainbar-option/mainbar-option.component';
import { InputComponent } from './input/input.component';
import { ButtonComponent } from './button/button.component';
import { RadioComponent } from './radio/radio.component';
import { CheckboxComponent } from './checkbox/checkbox.component';
import { GuardComponent } from './guard/guard.component';
import { LoadingComponent } from './loading/loading.component';
import { AvatarComponent } from './avatar/avatar.component';
import { UploaderComponent } from './uploader/uploader.component';
import { UploaderBillingComponent } from './uploader-billing/uploader-billing.component';
import { ScrollTopComponent } from './scrolltop/scrolltop.component';
import { ModalModule } from '../modal/modal.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    AppComponentPluginModule,
  ],
  declarations: [
    GuardComponent,
    UploaderComponent,
    UploaderBillingComponent,
    LoadingComponent,
    AvatarComponent,
    TopbarButtonComponent,
    MainbarOptionComponent,
    ButtonComponent,
    InputComponent,
    RadioComponent,
    CheckboxComponent,
    ScrollTopComponent,
  ],
  exports: [
    AppComponentPluginModule,
    GuardComponent,
    UploaderComponent,
    UploaderBillingComponent,
    LoadingComponent,
    AvatarComponent,
    TopbarButtonComponent,
    MainbarOptionComponent,
    ButtonComponent,
    InputComponent,
    RadioComponent,
    CheckboxComponent,
    ScrollTopComponent,
  ]
})
export class AppComponentCoreModule { }



// WEBPACK FOOTER //
// ./src/app/core/component/core/app-component-core.module.ts